var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChattitudeSquareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "139.4 103.48 2400 1687.88",
    style: {
      enableBackground: "new 139.4 103.48 2400 1687.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00AAFF;fill-opacity:0;}\r\n\t.st1{fill:#00AAFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,104.07949829101562)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -116.47,
    y: -80.55,
    className: "st0",
    width: 2352.94,
    height: 1640.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.22-80.55V1193.2l-326.7,367.07c664.4,0,2004.22,0,2147.38,0c198.22,0,205.56-194.55,205.56-205.56 V-76.88H210.22V-80.55z M1487.64,231.47c66.07,0,117.46,51.39,117.46,117.46s-51.39,117.46-117.46,117.46 c-66.07,0-117.46-51.39-117.46-117.46C1370.18,282.86,1421.57,231.47,1487.64,231.47z M999.43,231.47 c66.07,0,117.46,51.39,117.46,117.46s-51.39,117.46-117.46,117.46S881.97,415,881.97,348.93 C881.97,282.86,933.36,231.47,999.43,231.47z M1241.7,1244.59c-345.05,0-624.02-278.98-624.02-624.02 c0,0,312.01,135.82,635.04,135.82c330.37,0,609.34-135.82,609.34-135.82C1865.73,965.61,1586.75,1244.59,1241.7,1244.59z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChattitudeSquareLogo);
export default __webpack_public_path__ + "static/media/chattitude_square-logo.0690cdc33319f059d98105618f8762cf.svg";
export { ForwardRef as ReactComponent };